import he from 'he'
import View from './View.vue'
import DynamicNode from '../Dynamic.js'

export default DynamicNode({
  name: 'Navigation',

  group: 'block',

  draggable: true,

  isolating: true,

  atom: true,

  selectable: true,

  inline: false,

  marks: '',

  addAttributes() {
    return {
      id: {
        default: null,
      },
      ...this.options.schema.addAttributes,
      items: {
        default: {},
        renderHTML(attributes) {
          return {
            ...attributes,
            // Casting items here to ensure it is properly cast between an object and a string correctly
            items: he.encode(JSON.stringify(attributes.items)),
          }
        },
      },
    }
  },
}, View)
